import { useParams, useNavigate } from "react-router-dom";
import projects from "../data/projects";
import "../styles/projectPreview.css";
import { TbDeviceMobile, TbDeviceTablet, TbDeviceDesktop } from 'react-icons/tb';

import {
  LuChevronLeft,
} from "react-icons/lu";
import { useState } from "react";

export default function ProjectPreview() {
  const { type, id } = useParams();
  const navigate = useNavigate();

  const [device, setDevice] = useState("desktop");
  const projectList = projects[type];

  if (!projectList) {
    return <h2>Type not found</h2>;
  }

  const project = projectList.find((p) => p.id === Number(id));

  if (!project) {
    return <h2>Project not found</h2>;
  }

  const getIframeWidth = () => {
    switch (device) {
      case "mobile":
        return "375px";
      case "tablet":
        return "768px";
      default:
        return "100%";
    }
  };

  return (
    <div className="project-preview">
      <div className="project-preview__head">
        <button
          className="project-preview__head-back"
          onClick={() => navigate(-1)}
        >
          <LuChevronLeft />
          <span>Back</span>
        </button>
        <div className="project-preview__head__buttons">
          <button
            onClick={() => setDevice("desktop")}
            style={{
              color:
                device === "desktop"
                  ? "var(--primary-color)"
                  : "var(--text-color)",
            }}
          >
            <TbDeviceDesktop />

          </button>
          <button
            onClick={() => setDevice("tablet")}
            style={{
              color:
                device === "tablet"
                  ? "var(--primary-color)"
                  : "var(--text-color)",
            }}
          >
            <TbDeviceTablet />
          </button>
          <button
            onClick={() => setDevice("mobile")}
            style={{
              color:
                device === "mobile"
                  ? "var(--primary-color)"
                  : "var(--text-color)",
            }}
          >
            <TbDeviceMobile />

          </button>
        </div>
      </div>

      <div className="project-preview__body">
        <iframe
          className="project-preview__body-iframe"
          src={project.path}
          style={{
            width: getIframeWidth(),
          }}
          title={project.title}
        />
      </div>
    </div>
  );
}
